import { useHistory } from "react-router-dom";
import { Container } from "./styles";

const Home = () => {
  const history = useHistory();

  return (
    <Container className="rpgui-content">
      <section>
        <h1>Give the Give</h1>
        <div>
          <button
            onClick={() => history.push("/login")}
            className="rpgui-button"
          >
            <p>Login</p>
          </button>
          <button
            onClick={() => history.push("/signup")}
            className="rpgui-button"
          >
            <p>Cadastro</p>
          </button>
        </div>
      </section>
    </Container>
  );
};

export default Home;
